/* Findvoya store: real photo scenes with cut-out products placed in them.
   Each .fvst__photo is one area (Walk, Rally). Products keep a visible price tag;
   tapping a product or tag opens details with colours and Add to cart. No WebGL needed. */
(() => {
  document.querySelectorAll('.fvst').forEach((root) => {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    const q = (s) => root.querySelector(s);
    const tagLayer = q('.fvst__tags'), panel = q('.fvst__panel');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isPhone = () => root.clientWidth < 750;
    let data;
    try { data = JSON.parse(q('.fvst__data').textContent); } catch (e) { return; }
    root.classList.add('is-3d');

    /* scenes */
    const scenes = {};
    root.querySelectorAll('.fvst__photo').forEach((el) => {
      const ds = el.dataset;
      scenes[ds.scene] = {
        el, frame: el.querySelector('.fvst__frame'), bg: el.querySelector('.fvst__bg'),
        ratio: +ds.ratio, zoomDesk: +ds.zoomDesk, zoomPhone: +ds.zoomPhone, focusDesk: +ds.focusDesk, focusPhone: +ds.focusPhone, anchorY: +ds.anchorY,
        panX: 0, fw: 0, base: 0
      };
    });

    /* products: one per scene, each with variants; d.vi is the chosen variant */
    const products = [];
    const pick = (key, pref, zone = key) => {
      const d = data[key] && data[key][0]; if (!d) return;
      const p = pref ? d.variants.findIndex((v) => v.available && pref.test(v.title)) : -1;
      d.vi = p >= 0 ? p : Math.max(0, d.variants.findIndex((v) => v.available));
      const objs = [...root.querySelectorAll(`[data-product="${key}"]`)];
      const anchor = root.querySelector(`[data-product="${key}"][data-anchor]`) || objs[0];
      const hang = root.querySelector(`.fvst__hang[data-product="${key}"]`);
      products.push({ key, zone, d, objs, anchor, hang });
    };
    pick('walk', /grey|gray/i); // Grey shows its strap, so it hangs believably on the peg
    pick('cool', /blue/i, 'walk'); // the vest hangs on the next peg along
    pick('rally');
    const cur = (d) => d.variants[d.vi] || d.variants[0];

    const setHangSrc = (p, src) => {
      if (!p.hang || !src) return;
      p.hang.querySelectorAll('img').forEach((im) => { im.src = src; });
      p.hang.style.setProperty('--cut', `url("${src}")`);
    };
    products.forEach((p) => setHangSrc(p, cur(p.d).img));
    const hangs = products.filter((p) => p.hang).map((p, k) => ({ el: p.hang, shift: p.key === 'cool' ? 37 : 50, phase: k * 1.7, p }));

    /* price tags */
    const tags = products.map((p, i) => {
      const b = document.createElement('button'); b.type = 'button'; b.className = 'fvst__tag is-hidden';
      b.innerHTML = '<span class="fvst__tag-name"></span><span class="fvst__tag-price"></span>';
      const n = new Set(p.d.variants.map((v) => v.o1 || v.title)).size, label = n > 1 ? `${p.d.short}, ${n} colours` : p.d.short;
      b.querySelector('.fvst__tag-name').textContent = label;
      b.querySelector('.fvst__tag-price').textContent = cur(p.d).price;
      b.setAttribute('aria-label', `${label}, ${cur(p.d).price}. Show details`);
      b.addEventListener('click', () => open(i)); tagLayer.appendChild(b); return b;
    });

    /* layout: cover the section with the photo, keep the product in view, allow horizontal pan */
    function layout(sc) {
      const W = root.clientWidth, H = root.clientHeight, phone = isPhone();
      const fw = Math.max(W, H * sc.ratio) * (phone ? sc.zoomPhone : sc.zoomDesk), fh = fw / sc.ratio;
      const focus = phone ? sc.focusPhone : sc.focusDesk;
      sc.fw = fw; sc.base = W / 2 - focus * fw;
      const left = Math.min(0, Math.max(W - fw, sc.base + sc.panX));
      const top = Math.min(0, Math.max(H - fh, H * 0.32 - sc.anchorY * fh));
      Object.assign(sc.frame.style, { width: fw + 'px', height: fh + 'px', left: left + 'px', top: top + 'px' });
    }
    const layoutAll = () => Object.values(scenes).forEach(layout);
    new ResizeObserver(layoutAll).observe(root); layoutAll();

    let zone = 'walk', selected = -1, visible = true, px = 0, py = 0, pxs = 0, pys = 0;
    let drag = null, moved = 0;
    Object.values(scenes).forEach((sc) => {
      sc.el.addEventListener('pointerdown', (e) => { drag = { x: e.clientX, start: sc.panX, sc }; moved = 0; });
      sc.el.addEventListener('pointermove', (e) => {
        if (!drag || drag.sc !== sc) return;
        const W = root.clientWidth, dx = e.clientX - drag.x; moved = Math.abs(dx);
        sc.panX = Math.min(-sc.base, Math.max(W - sc.fw - sc.base, drag.start + dx)); layout(sc);
      });
    });
    addEventListener('pointerup', () => { drag = null; setTimeout(() => { moved = 0; }, 0); });
    root.addEventListener('pointermove', (e) => { const r = root.getBoundingClientRect(); px = ((e.clientX - r.left) / r.width) * 2 - 1; py = ((e.clientY - r.top) / r.height) * 2 - 1; });

    products.forEach((p, i) => p.objs.forEach((o) => o.addEventListener('click', (e) => { if (moved > 6) { e.preventDefault(); return; } open(i); })));

    const setZone = (z) => {
      zone = z; close();
      Object.entries(scenes).forEach(([k, sc]) => { sc.el.hidden = k !== z; });
      if (scenes[z] && scenes[z].bg.loading === 'lazy') scenes[z].bg.loading = 'eager';
      root.querySelectorAll('.fvst__zone[data-zone]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.zone === z)));
      layoutAll();
    };
    root.querySelectorAll('.fvst__zone[data-zone]').forEach((b) => b.addEventListener('click', () => setZone(b.dataset.zone)));
    setZone('walk');

    /* details panel */
    const addBtn = q('.fvst__add'), cartLink = q('.fvst__cart');
    function open(i) {
      const p = products[i]; if (!p) return; if (p.zone !== zone) setZone(p.zone);
      selected = i; const d = p.d;
      q('.fvst__panel-zone').textContent = { walk: 'For the walk', cool: 'For hot walks', rally: 'For home practice' }[p.key] || '';
      q('.fvst__panel-name').textContent = d.name; q('.fvst__panel-desc').textContent = d.desc;
      renderSwatches(i);
      fill(p); panel.hidden = false; tags.forEach((t, k) => t.classList.toggle('is-active', k === i));
      q('.fvst__close').focus({ preventScroll: true });
    }
    /* one row of buttons per option (colour, then size) when the product has two options */
    function renderSwatches(i) {
      const p = products[i], d = p.d, sw = q('.fvst__swatches'), v0 = cur(d);
      sw.innerHTML = ''; sw.hidden = d.variants.length < 2;
      const two = d.variants.every((v) => v.o1 && v.o2);
      const rows = two ? ['o1', 'o2'] : [null];
      rows.forEach((opt) => {
        const row = document.createElement('div'); row.className = 'fvst__swatch-row';
        const values = opt ? [...new Set(d.variants.map((v) => v[opt]))] : d.variants.map((v) => v.title);
        values.forEach((val, k) => {
          const target = opt
            ? d.variants.findIndex((v) => v[opt] === val && v[opt === 'o1' ? 'o2' : 'o1'] === v0[opt === 'o1' ? 'o2' : 'o1'])
            : k;
          const tv = d.variants[target] || d.variants.find((v) => v[opt] === val);
          const b = document.createElement('button'); b.type = 'button'; b.className = 'fvst__swatch'; b.setAttribute('role', 'radio');
          b.textContent = val; b.setAttribute('aria-checked', String(opt ? v0[opt] === val : k === d.vi));
          if (tv && !tv.available) b.classList.add('is-out');
          b.addEventListener('click', () => pickVariant(i, target >= 0 ? target : d.variants.indexOf(tv)));
          row.appendChild(b);
        });
        sw.appendChild(row);
      });
    }
    function fill(p) {
      const v = cur(p.d);
      q('.fvst__panel-price').textContent = v.price; q('.fvst__view').href = v.url; cartLink.hidden = true;
      addBtn.disabled = !(v.variant && v.available); addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
    }
    function pickVariant(i, k) {
      const p = products[i]; if (k < 0) return; p.d.vi = k;
      renderSwatches(i); fill(p); setHangSrc(p, cur(p.d).img);
    }
    function close() { selected = -1; panel.hidden = true; tags.forEach((t) => t.classList.remove('is-active')); }
    q('.fvst__close').addEventListener('click', close);
    root.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    addBtn.addEventListener('click', async () => {
      const v = selected >= 0 && cur(products[selected].d); if (!v || !v.variant) return;
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      try {
        const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const res = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.variant, quantity: 1 }] }) });
        if (!res.ok) throw new Error('add failed');
        addBtn.textContent = 'Added'; cartLink.hidden = false;
      } catch (err) { addBtn.textContent = 'Could not add. Try again'; addBtn.disabled = false; }
    });

    /* frame loop: parallax, gentle sway, tags follow their product */
    new IntersectionObserver((en) => { visible = en[0].isIntersecting; }).observe(root);
    const tick = (t) => {
      requestAnimationFrame(tick);
      if (!visible) return;
      const sc = scenes[zone]; if (!sc) return;
      pxs += (px - pxs) * 0.08; pys += (py - pys) * 0.08;
      const zoom = selected >= 0 ? 1.05 : 1;
      sc.frame.style.transform = `translate(${(-pxs * 10).toFixed(1)}px, ${(-pys * 6).toFixed(1)}px) scale(${zoom})`;
      if (zone === 'walk') hangs.forEach((h) => {
        const active = selected >= 0 && products[selected] === h.p;
        const sway = reduce ? 0 : Math.sin(t / 900 + h.phase) * (active ? 2.4 : 0.9);
        h.el.style.transform = `translate(-${h.shift}%, 0) translate(${(-pxs * 6).toFixed(1)}px, 0) perspective(900px) rotateY(20deg) rotate(${sway.toFixed(2)}deg)`;
      });
      const o = root.getBoundingClientRect();
      products.forEach((p, i) => {
        if (p.zone !== zone) { tags[i].classList.add('is-hidden'); return; }
        const img = p.anchor.querySelector('img:last-of-type') || p.anchor, r = img.getBoundingClientRect();
        const x = r.left - o.left + r.width / 2, y = r.bottom - o.top + 12;
        tags[i].style.transform = `translate(-50%, 0) translate(${x.toFixed(1)}px, ${Math.min(y, o.height - 70).toFixed(1)}px)`;
        tags[i].classList.toggle('is-hidden', !(img.complete && img.naturalWidth));
      });
    };
    requestAnimationFrame(tick);
  });
})();
